<template>
  <tbody>
    <tr>
      <td style="padding-bottom: 30px;">Total</td>
      <td style="padding-bottom: 30px;"></td>
      <td style="padding-bottom: 30px;"></td>
      <td style="padding-bottom: 30px;">{{ total?.rate | currency }}</td>
      <td style="padding-bottom: 30px;">
        {{ total?.agreed_value | currency }}
      </td>
      <td style="padding-bottom: 30px;">
        <template v-if="!vatRegistered">{{
          totalPaid | currency('£', false)
        }}</template>
      </td>
      <td style="padding-bottom: 30px;"></td>
    </tr>

    <tr>
      <td>VAT @ 20%</td>
      <td></td>
      <td></td>
      <td>{{ total?.rate_vat | currency }}</td>
      <td>{{ total?.agreed_value_vat | currency('£', false) }}</td>
      <td></td>
      <td></td>
    </tr>

    <tr>
      <td style="padding-bottom: 30px;">Grand Total</td>
      <td style="padding-bottom: 30px;"></td>
      <td style="padding-bottom: 30px;"></td>
      <td style="padding-bottom: 30px;">{{ valueGrandTotal | currency }}</td>
      <td style="padding-bottom: 30px;">
        {{ agreedGrandTotal | currency('£', false) }}
      </td>
      <td style="padding-bottom: 30px;">
        <template v-if="vatRegistered">{{
          totalPaid | currency('£', false)
        }}</template>
      </td>
      <td style="padding-bottom: 30px;"></td>
    </tr>
  </tbody>
</template>
<script>
export default {
  props: {
    rates: {
      type: Array,
      required: true
    },
    totals: {
      type: Array,
      required: true
    },
    group: {
      type: Object,
      required: true
    },
    vatRegistered: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  computed: {
    total() {
      return this.totals.find(total => total.rate_group_id === this.group.id);
    },

    valueGrandTotal() {
      return this.grandTotal(this.total?.rate, this.total?.rate_vat);
    },

    agreedGrandTotal() {
      return this.grandTotal(
        this.total?.agreed_value,
        this.total?.agreed_value_vat
      );
    },

    totalPaid() {
      return this.rates.reduce((total, rate) => total + rate.total_paid, 0);
    }
  },

  methods: {
    vat(value) {
      if (typeof value === 'number') {
        return value * 0.2;
      }

      return null;
    },

    grandTotal(total, vat) {
      if (typeof total === 'number') {
        return total + vat;
      }

      return null;
    }
  }
};
</script>
